<template>
  <div class="mx-auto my-2">
    <v-card class="basil">
      <v-card-title class="text-left justify-left py-6">
        Pre-service
      </v-card-title>

      <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
        <v-tab v-for="tabItem in tabItems" :key="tabItem">
          {{ tabItem }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="tabItem in tabItems" :key="tabItem">
          <div v-if="tabItem == 'Generic Entry'" style="min-height: 100vh">
            <GenericEntries></GenericEntries>
          </div>
          <div v-if="tabItem == 'Post Basic'" style="min-height: 100vh">
            <PostBasic></PostBasic>
          </div>
          <div v-if="tabItem == 'Post Graduate'" style="min-height: 100vh">
            <PostGraduate></PostGraduate>
          </div>
          <div v-if="tabItem == 'NIMEI Program'" style="min-height: 100vh">
            <NimeiProgram></NimeiProgram>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import GenericEntries from "./GenericEntry/generic-entries";
import PostBasic from "./PostBasic/post-basics.vue";
import PostGraduate from "./PostGraduate/post-gaduate.vue";
import NimeiProgram from "@/components/Graduates/NimeiProgram/nimei-program.vue";

export default {
  components: {
    NimeiProgram,
    GenericEntries,
    PostBasic,
    PostGraduate
  },
  data() {
    return {
      tab: null,
      tabItems: ["Generic Entry", "Post Basic", "Post Graduate", "NIMEI Program"],
    };
  },
};
</script>

<style scoped>
.basil {
  background-color: #eff6ff !important;
}

.basil--text {
  color: #356859 !important;
}

.basil {
  background-color: #eff6ff !important;
}

.basil--text {
  color: #356859 !important;
}

.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
> .v-input__control
> .v-input__slot {
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 10%), 0 1px 2px 0 rgb(0 0 0 / 6%) !important;
}
</style>
